import { render, staticRenderFns } from "./CampaignNotesBasic.vue?vue&type=template&id=107031bf&functional=true"
import script from "./CampaignNotesBasic.vue?vue&type=script&lang=js"
export * from "./CampaignNotesBasic.vue?vue&type=script&lang=js"
import style0 from "./CampaignNotesBasic.vue?vue&type=style&index=0&id=107031bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.98.0__lodash@4._0ede07508368b0c10a5f63bb0b6a47bb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports